module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form'
    ],
}